import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
    createTextVNode as _$ct,
} from 'intact';
import {Tour, Button, Switch} from 'kpc';

var _$tmp0 = {
    'style': 'margin-left: 10px;'
};
var _$tmp1 = {
    'style': 'margin-bottom: 10px;'
};
var _$tmp2 = {
    'style': 'margin-top: 20px;'
};

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$ce(2, 'div', [
            _$cc(Button, {
                'id': 'maskDemo1',
                'children': '目标元素1'
            }),
            _$cc(Button, {
                'id': 'maskDemo2',
                'style': 'margin-left: 20px;',
                'children': '目标元素2'
            })
        ], 4 /* HasNonKeyedChildren */, 'example-container'),
        _$cc(Tour, {
            'visible': this.get('showTour'),
            'data': this.get('tourData'),
            'maskClosable': this.get('maskClosable'),
            'ev-finish': this.finishTour,
            'ev-$model:value': function($v) {
                $this.set('currentStep', $v);
            },
            'value': $this.get('currentStep')
        }),
        _$ce(2, 'div', [
            _$ce(2, 'div', [
                _$cc(Switch, {
                    'ev-$model:value': function($v) {
                        $this.set('maskClosable', $v);
                    },
                    'value': $this.get('maskClosable')
                }),
                _$ce(2, 'span', [
                    _$ct('点击遮罩关闭引导: '),
                    this.get('maskClosable') ? '启用' : '禁用'
                ], 0 /* UnknownChildren */, null, _$tmp0)
            ], 4 /* HasNonKeyedChildren */, null, _$tmp1),
            _$cc(Button, {
                'ev-click': this.startTour,
                'children': '\n            启动引导\n        '
            })
        ], 4 /* HasNonKeyedChildren */, null, _$tmp2)
    ], 4 /* HasNonKeyedChildren */);
};